export default __webpack_public_path__ + "static/later-board-a69c129bfd50419e7eb9bde59164dd4b.webp";